import { Reveal } from '@progress/kendo-react-animation';
import { Button } from '@progress/kendo-react-buttons';
import { Card as KendoCard, CardHeader } from '@progress/kendo-react-layout';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Header from './Header';

export default function CollapsableCard(props) {
  const [expanded, setExpanded] = useState(
    props.expanded === undefined ? true : props.expanded
  );
  const [onExit, setOnExit] = useState(true);

  useEffect(() => {
    if (props.expanded !== undefined) setExpanded(props.expanded);
  }, [props.expanded]);

  const cardHeader = (<CardHeader />).type;
  const header = (<Header />).type;

  return (
    <div>
      <div
        style={
          props.canCollapse !== false
            ? {
              cursor: 'pointer',
              marginLeft: '15px',
            }
            : {}
        }
        className={'flex-panel'}
        data-testid='collapsable-card'
        onClick={() => {
          if (props.canCollapse !== false) setExpanded(!expanded);
        }}
      >
        {props.canCollapse === undefined && !props.canCollapse && expanded && (
          <div
            className="inline"
            style={{
              padding: '15px',
              color: '#707070',
              margin: '15px 15px 0 0',
              border: '1px #f3f5f5 solid',
              boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)',
            }}
          >
            {props.children.filter(
              (children) =>
                children.type === header || children.type === cardHeader
            )}
            <Button
              style={{
                float: 'right',
                marginLeft: 'auto',
                backgroundColor: 'transparent',
                border: 'none',
              }}
              onClick={() => {
                if (props.canCollapse !== false) setExpanded(!expanded);
              }}
              icon={expanded ? 'chevron-down' : 'chevron-up'}
              data-testid='collapsable-card-button'
            ></Button>
          </div>
        )}
        {!expanded && onExit && props.children?.length > 0 && (
          <div
            className="margin-title"
            style={{
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              marginTop: '15px',
              border: '1px #f3f5f5 solid',
              boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)',
              padding: '15px',
            }}
            onClick={() => {
              if (props.canCollapse !== false) setExpanded(!expanded);
            }}
          >
            {props.children.filter(
              (children) =>
                children.type === header || children.type === cardHeader
            )}
            <span
              style={{
                fontWeight: 600,
                fontSize: '1.5rem',
                marginLeft: 'auto',
                marginRight: '1rem',
              }}
              className={
                expanded
                  ? 'k-icon k-font-icon k-i-arrow-chevron-down'
                  : 'k-icon k-font-icon k-i-arrow-chevron-up'
              }
            />
          </div>
        )}
      </div>
      <KendoCard
        className={`custom-card-panelbar-wrapper card-container ${props.type !== undefined ? props.type : 'info'
          }`}
        style={
          props.style !== undefined
            ? props.style
            : {
              display: 'grid',
              backgroundColor: expanded ? '#f3f5f5' : 'white',
              border: !expanded ? 'none' : '',
              boxShadow: !expanded ? 'none' : '',
              visibility: !expanded ? 'hidden' : '',
              height: !expanded ? '0' : ''
            }
        }>
        <Reveal style={{ zIndex: 'inherit' }}
          onEntered={() => setOnExit(false)}
          onExited={() => setOnExit(true)}>
          {props.children.filter !== undefined ? props.children.filter((children) => children.type !== header && children.type !== cardHeader) : props.children}
        </Reveal>
      </KendoCard>
    </div>
  );
}

CollapsableCard.propTypes = {
  type: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf(['info', 'error', 'none']),
  ]),
  style: PropTypes.object,
  canCollapse: PropTypes.bool,
  expanded: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
